"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImprobedOpSet = void 0;
const ConstrainedFloatingPoint_1 = require("../../util/types/ConstrainedFloatingPoint");
exports.ImprobedOpSet = [
    // 0: abs:
    ([z0, z1, z2]) => {
        return (0, ConstrainedFloatingPoint_1.asConstrainedFloatingPoint)(Math.abs(z0));
    },
    // 1: sqrt:
    ([z0, z1, z2]) => {
        return (0, ConstrainedFloatingPoint_1.asConstrainedFloatingPoint)(Math.sqrt(Math.abs(z0)));
    },
    // 2: sqr
    ([z0, z1, z2]) => {
        return (0, ConstrainedFloatingPoint_1.asConstrainedFloatingPoint)(z0 ** 2);
    },
    // 3: cube
    ([z0, z1, z2]) => {
        return (0, ConstrainedFloatingPoint_1.asConstrainedFloatingPoint)(z0 ** 3);
    },
    // 4: exp
    ([z0, z1, z2]) => {
        return (0, ConstrainedFloatingPoint_1.asConstrainedFloatingPoint)((2 * Math.exp(z0 + 1) - Math.E ** 2 - 1) / (Math.E ** 2 - 1));
    },
    // 5: sin
    ([z0, z1, z2]) => {
        return (0, ConstrainedFloatingPoint_1.asConstrainedFloatingPoint)(Math.sin(z0));
    },
    // 6: cos
    ([z0, z1, z2]) => {
        return (0, ConstrainedFloatingPoint_1.asConstrainedFloatingPoint)(Math.cos(z0));
    },
    // 7: tanh
    ([z0, z1, z2]) => {
        return (0, ConstrainedFloatingPoint_1.asConstrainedFloatingPoint)(Math.tanh(z0));
    },
    // 8: inv
    ([z0, z1, z2]) => {
        return (0, ConstrainedFloatingPoint_1.asConstrainedFloatingPoint)(-1 * z0);
    },
    // 9: step
    ([z0, z1, z2]) => {
        return (0, ConstrainedFloatingPoint_1.asConstrainedFloatingPoint)(z0 < 0.0 ? 0.0 : 1.0);
    },
    // 10: hyp
    ([z0, z1, z2]) => {
        return (0, ConstrainedFloatingPoint_1.asConstrainedFloatingPoint)(Math.sqrt((z0 ** 2 + z1 ** 2) / 2));
    },
    // 11: add
    ([z0, z1, z2]) => {
        return (0, ConstrainedFloatingPoint_1.asConstrainedFloatingPoint)((z0 + z1) / 2);
    },
    // 12: sub
    ([z0, z1, z2]) => {
        return (0, ConstrainedFloatingPoint_1.asConstrainedFloatingPoint)((z0 - z1) / 2);
    },
    // 13: mult
    ([z0, z1, z2]) => {
        return (0, ConstrainedFloatingPoint_1.asConstrainedFloatingPoint)(z0 * z1);
    },
    // 14: max
    ([z0, z1, z2]) => {
        return (0, ConstrainedFloatingPoint_1.asConstrainedFloatingPoint)(z0 >= z1 ? z0 : z1);
    },
    // 15: min
    ([z0, z1, z2]) => {
        return (0, ConstrainedFloatingPoint_1.asConstrainedFloatingPoint)(z0 <= z1 ? z0 : z1);
    },
    // 16: and
    ([z0, z1, z2]) => {
        return (0, ConstrainedFloatingPoint_1.asConstrainedFloatingPoint)((z0 > 0.0 && z1 > 0.0) ? 1.0 : -1.0);
    },
    // 17: or
    ([z0, z1, z2]) => {
        return (0, ConstrainedFloatingPoint_1.asConstrainedFloatingPoint)((z0 > 0.0 || z1 > 0.0) ? 1.0 : -1.0);
    },
    // 18: rmux
    ([z0, z1, z2]) => {
        return (0, ConstrainedFloatingPoint_1.asConstrainedFloatingPoint)((z0 > 0.0 || z1 > 0.0) ? 1.0 : -1.0);
    },
];
